import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  editButton: {
    description: 'view notes tooltip edit button text',
    defaultMessage: 'Edit',
    id: 'J3eH9b',
  },
  moreNotes: {
    defaultMessage: '+ {remainingNotes} More { remainingNotes, plural, one {Note} other {Notes}}',
    description: 'noteColumn.moreNotes',
    id: 'wiRKKA',
  },
});
